import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

import { getSearchRecommended } from "@/app/[lang]/flights/components/FlightSearchDestinationContentComponent/components/getSearchRecommended";
import type { ResponseSearchRecommendedInterface } from "@/libs/client/goApi/flight/flightServiceInterfaces/getDestinationsRecommendedInterface";

interface UseDirectFlightInterface {
  isDirectFlight: boolean;
  responseDisplay: ResponseSearchRecommendedInterface[] | null;
  currentLang: string;
  isLoading: boolean;
  getDisplayNameByFlight: () => void;
  setIsDirectFlight: (data: boolean) => void;
  setCurrentLang: (value: string) => void;
  setIsLoading: (data: boolean) => void;
}

const getDisplayNameByFlight = async (
  useDirectFlight: (data: boolean) => void,
) => {
  useDirectFlight(true);
  const response = await getSearchRecommended();
  useDirectFlight(false);
  return response;
};

export const useDirectFlight = create<UseDirectFlightInterface>()(
  devtools(
    persist(
      (set, get) => ({
        isLoading: false,
        currentLang: "",
        responseDisplay: [],
        isDirectFlight: false,
        setCurrentLang: (data: string) =>
          set((state) => ({ currentLang: data })),
        getDisplayNameByFlight: async () => {
          const hasCacheData = get().responseDisplay; // if have cache use cache by current lang
          const setState = (value: boolean = false) => {
            useDirectFlight.setState({ isLoading: value });
          };
          const data = await getDisplayNameByFlight(setState);

          set(() => ({ responseDisplay: data }));
        },
        setIsDirectFlight: (data: boolean) =>
          set((state) => ({ isDirectFlight: data })),
        setIsLoading: (data: boolean) => set((state) => ({ isLoading: data })),
      }),
      {
        name: "DIRECT_FLIGHT",
      },
    ),
  ),
);
